"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  /* 方法 当前组件可使用的方法 */
  methods: {
    /* el-pagination 回调事件 */
    /**
     * @description: pageSize 改变时会触发
     * @param { String } pageSize 每页条目
     * @return { void }
     */
    pSizeChange: function pSizeChange(pageSize) {
      var _this = this;
      this.pagination.pageSize = pageSize;
      this.$$listenersEmit('size-change', pageSize);
      this.$$debounce(function () {
        _this.$$listenersEmit('pagination-change', _this.pagination);
      }, 10);
    },
    /**
     * @description: currentPage 改变时会触发
     * @param { String } currentPage 当前页
     * @return { void }
     */
    pCurrentChange: function pCurrentChange(currentPage) {
      var _this2 = this;
      this.pagination.currentPage = currentPage;
      this.$$listenersEmit('current-change', currentPage);
      this.$$debounce(function () {
        _this2.$$listenersEmit('pagination-change', _this2.pagination);
      }, 10);
    },
    /**
     * @description: 用户点击上一页按钮改变当前页后触发
     * @param { String } currentPage 当前页
     * @return { void }
     */
    pPrevClick: function pPrevClick(currentPage) {
      this.$$listenersEmit('prev-click', currentPage);
    },
    /**
     * @description: 用户点击下一页按钮改变当前页后触发
     * @param { String } currentPage 当前页
     * @return { void }
     */
    pNextClick: function pNextClick(currentPage) {
      this.$$listenersEmit('next-click', currentPage);
    }
  }
};